// extracted by css-extract-rspack-plugin
export default {"videoLinkMobile":"video-link-mobile--YUjn4y3vTlsWqgli","videoLinkDesktop":"video-link-desktop--ay3pY3RCqQ6WIS9C"};